export const roomTypes = [
    {
        id: 'club-standart',
        title: 'Одноместный стандарт - 14 м²',
        description: 'Уютный однокомнатный номер со всем необходимым для комфортного отдыха. Расположен на 4, 5 этаже Спального корпуса № 1.',
        features: [
            'Однокомнатный',
            'Холодильник',
            'Душевая кабина',
            'Телевизор',
            'Кондиционер',
            'Фен'
        ],
        images: [
            '/Assets/Rooms/1/1.jpg',
            '/Assets/Rooms/1/2.jpg',
            '/Assets/Rooms/1/3.jpg',
            '/Assets/Rooms/1/4.jpg',
            '/Assets/Rooms/1/5.jpg',
            '/Assets/Rooms/1/6.jpg',
            '/Assets/Rooms/1/7.jpg',
            '/Assets/Rooms/1/8.jpg',
            '/Assets/Rooms/1/9.jpg',
            '/Assets/Rooms/1/10.jpg',
            '/Assets/Rooms/1/11.jpg',
            '/Assets/Rooms/1/12.jpg',
        ],
        price: 'от 11 200 руб/сутки',
    },
    {
        id: 'club-standart',
        title: 'Двухместный стандарт - 18 м²',
        description: 'Уютный однокомнатный номер со всем необходимым для комфортного отдыха.',
        features: [
            'Однокомнатный',
            'Две односпальные кровати',
            'Холодильник',
            'Кондиционер',
            'Утюг',
            'Душевая кабина',
            'Санузел'
        ],
        images: [
            '/Assets/Rooms/2/1.jpg',
            '/Assets/Rooms/2/2.jpg',
            '/Assets/Rooms/2/3.jpg',
            '/Assets/Rooms/2/4.jpg',
            '/Assets/Rooms/2/5.jpg',
            '/Assets/Rooms/2/6.jpg',
            '/Assets/Rooms/2/7.jpg',
            '/Assets/Rooms/2/8.jpg',
            '/Assets/Rooms/2/9.jpg',
            '/Assets/Rooms/2/10.jpg',
            '/Assets/Rooms/2/11.jpg',
            '/Assets/Rooms/2/12.jpg',
            '/Assets/Rooms/2/13.jpg',
            '/Assets/Rooms/2/14.jpg',
        ],
        price: 'от 9 000 руб/сутки',
    },
    {
        id: 'club-standart',
        title: 'Одноместный стандарт (лечебный корпус) - 14 м²',
        description: 'Уютный однокомнатный номер со всем необходимым для комфортного отдыха. Расположен в лечебный корпусе.',
        features: [
            'Телевизор',
            'Двуспальная кровать',
            'Холодильник',
            'Сейф',
            'Балкон',
            'Оборудованная ванная комната'
        ],
        images: [
            '/Assets/Rooms/3/1.jpg',
            '/Assets/Rooms/3/2.jpg',
            '/Assets/Rooms/3/3.jpg',
            '/Assets/Rooms/3/4.jpg',
            '/Assets/Rooms/3/5.jpg',
        ],
        price: 'от 9 600 руб/сутки',
    },
    {
        id: 'club-standart',
        title: 'Двухместный стандарт (лечебный корпус) - 16 - 18 м²',
        description: 'Уютный однокомнатный номер со всем необходимым для комфортного отдыха. Расположен в лечебный корпусе.',
        features: [
            'Телевизор',
            'Двуспальная кровать или две односпальные',
            'Сейф',
            'Балкон',
            'Оборудованная ванная комната',
            'Электронный замок'
        ],
        images: [
            '/Assets/Rooms/4/1.jpg',
            '/Assets/Rooms/4/2.jpg',
            '/Assets/Rooms/4/3.jpg',
            '/Assets/Rooms/4/4.jpg',
            '/Assets/Rooms/4/5.jpg',
            '/Assets/Rooms/4/6.jpg',
            '/Assets/Rooms/4/7.jpg',
            '/Assets/Rooms/4/8.jpg',
            '/Assets/Rooms/4/9.jpg',
            '/Assets/Rooms/4/10.jpg',
        ],
        price: 'от 7 600 руб/сутки',
    },
    {
        id: 'club-standart',
        title: 'Двухместный стандарт «Студио» - 25 м²',
        description: 'Уютный однокомнатный номер со всем необходимым для комфортного отдыха.',
        features: [
            'Телевизор',
            'Двуспальная кровать или две односпальные',
            'Сейф',
            'Холодильник',
            'Халат',
            'Оборудованная ванная комната'
        ],
        images: [
            '/Assets/Rooms/5/1.jpg',
            '/Assets/Rooms/5/2.jpg',
            '/Assets/Rooms/5/3.jpg',
            '/Assets/Rooms/5/4.jpg',
            '/Assets/Rooms/5/5.jpg',
            '/Assets/Rooms/5/6.jpg',
            '/Assets/Rooms/5/7.jpg',
            '/Assets/Rooms/5/8.jpg',
            '/Assets/Rooms/5/9.jpg',
            '/Assets/Rooms/5/10.jpg',
        ],
        price: 'от 9 700 руб/сутки',
    },
{
        id: 'club-standart',
        title: 'Двухместный двухкомнатный Стандарт - 35 м²',
        description: 'Уютный двухкомнатный номер со всем необходимым для комфортного отдыха.',
        features: [
            'Электронный замок',
            'Двуспальная кровать и диван',
            'Кондиционер',
            'Холодильник',
            'Сейф',
            'Ванная комната',
            'Телевизор'
        ],
        images: [
            '/Assets/Rooms/6/1.jpg',
            '/Assets/Rooms/6/2.jpg',
            '/Assets/Rooms/6/3.jpg',
            '/Assets/Rooms/6/4.jpg',
            '/Assets/Rooms/6/5.jpg',
            '/Assets/Rooms/6/6.jpeg',
            '/Assets/Rooms/6/7.jpeg',
            '/Assets/Rooms/6/8.jpeg',
            '/Assets/Rooms/6/9.jpeg',
            '/Assets/Rooms/6/10.jpg',
            '/Assets/Rooms/6/11.jpg',
            '/Assets/Rooms/6/12.jpg',
        ],
        price: 'от 11 300 руб/сутки',
    },
{
        id: 'club-standart',
        title: 'Двухместный двухкомнатный «Люкс» - 33 м²',
        description: 'Уютный однокомнатный номер со всем необходимым для комфортного отдыха.',
        features: [
            'Двухкомнатный',
            'Две односпальные кровати и диван',
            '2 ЖК телевизора',
            'Электронный замок',
            'Балкон',
            'Оборудованная ванная комната',
            'Кондиционер',
        ],
        images: [
            '/Assets/Rooms/7/1.jpg',
            '/Assets/Rooms/7/2.jpg',
            '/Assets/Rooms/7/3.jpg',
            '/Assets/Rooms/7/4.jpg',
            '/Assets/Rooms/7/5.jpg',
            '/Assets/Rooms/7/6.jpg',
            '/Assets/Rooms/7/7.jpg',
            '/Assets/Rooms/7/8.jpg',
            '/Assets/Rooms/7/9.jpg',
            '/Assets/Rooms/7/10.jpg',
            '/Assets/Rooms/7/11.jpg',
            '/Assets/Rooms/7/12.jpg',
        ],
        price: 'от 12 300 руб/сутки',
    },
{
        id: 'club-standart',
        title: 'Двухместный двухкомнатный люкс «Премьер» - 33 м²',
        description: 'Уютный двухкомнатный номер со всем необходимым для комфортного отдыха.',
        features: [
            'Двухкомнатный',
            'Две односпальные кровати и диван',
            '2 ЖК телевизора',
            'Электронный замок',
            'Балкон',
            'Оборудованная ванная комната',
            'Кондиционер',
        ],
        images: [
            '/Assets/Rooms/8/1.jpg',
            '/Assets/Rooms/8/2.jpg',
            '/Assets/Rooms/8/3.jpg',
            '/Assets/Rooms/8/4.jpg',
            '/Assets/Rooms/8/5.jpg',
            '/Assets/Rooms/8/6.jpg',
            '/Assets/Rooms/8/7.jpg',
            '/Assets/Rooms/8/8.jpg',
            '/Assets/Rooms/8/9.jpg',
            '/Assets/Rooms/8/10.jpg',
            '/Assets/Rooms/8/11.jpg',
        ],
        price: 'от 16 300 руб/сутки',
    },
    {
        id: 'club-standart',
        title: 'Двухместный трехкомнатный «Апартамент» - 93/127 м²',
        description: 'Уютный трехкомнатный номер со всем необходимым для комфортного отдыха.',
        features: [
            'Трехкомнатный',
            '2 спальни',
            '3 телевизора',
            '2 санузла с биде',
            'Гидросауна',
            'Оборудованная ванная комната',
            'Гардеробная комната',
            'Сейф',
            'Кухня',
        ],
        images: [
            '/Assets/Rooms/9/1.jpg',
            '/Assets/Rooms/9/2.jpg',
            '/Assets/Rooms/9/3.jpg',
            '/Assets/Rooms/9/4.jpg',
            '/Assets/Rooms/9/5.jpg',
            '/Assets/Rooms/9/6.jpg',
            '/Assets/Rooms/9/7.jpg',
            '/Assets/Rooms/9/8.jpg',
            '/Assets/Rooms/9/9.jpg',
            '/Assets/Rooms/9/10.jpg',
            '/Assets/Rooms/9/11.jpg',
            '/Assets/Rooms/9/12.jpg',
        ],
        price: 'от 30 700 руб/сутки',
    },

];